'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCalculator = function TiCalculator(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 35h-13.3c-2.8 0-5-2.2-5-5v-20c0-2.8 2.2-5 5-5h13.3c2.8 0 5 2.2 5 5v20c0 2.8-2.2 5-5 5z m-13.3-26.7c-0.9 0-1.7 0.8-1.7 1.7v20c0 0.9 0.8 1.7 1.7 1.7h13.3c1 0 1.7-0.8 1.7-1.7v-20c0-0.9-0.7-1.7-1.7-1.7h-13.3z m3.3 10c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m-10 5c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m-10 5c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m5 0c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6z m-1.6-16.6v1.6h-10v-1.6h10z m1.6-1.7h-13.3v5h13.3v-5z' })
        )
    );
};

exports.default = TiCalculator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/calculator.js
// module id = 3770
// module chunks = 0